import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Button, Tab } from "@mui/material";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import BillingRulesEditor from "../../../components/accounting/BillingRulesEditor";
import BusinessEntityDetailsContainer from "../../../components/asset-management/BusinessEntityDetails";
import HeaderTitle from "../../../components/common/HeaderTitle";
import {
  BusinessEntity,
  BusinessEntityType,
  RateTableEntityType,
} from "../../../graphql/generated";
import { useNavigationOptions } from "../../LayoutRoutes";
import { useTranslation } from "react-i18next";
import NationalFuelRateTableDialog from "../../../components/accounting/NationalFuelRateTable/NationalFuelRateTableDialog";
import RatingTableEditorContainer from "../../../components/accounting/RatingTableEditor";
import { testIds } from "./ViewCustomer.testIds";

function ViewCustomer() {
  const { id } = useParams();
  const [isRateTableOpen, setIsRateTableOpen] = useState(false);
  const { setNavigationOptions } = useNavigationOptions();
  const { t } = useTranslation(["common", "billingRules"]);
  const onLoad = useCallback(
    (businessEntity: Pick<BusinessEntity, "code">) => {
      setNavigationOptions({
        title: (
          <HeaderTitle
            label={t("customer", "Customer")}
            suffix={businessEntity?.code || ""}
          />
        ),
        showBackIcon: true,
      });
    },
    [setNavigationOptions, t]
  );
  const [activeTab, setActiveTab] = useState("DETAILS");
  if (!id) {
    return null;
  }
  return (
    <TabContext value={activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList
          onChange={(event, value) => setActiveTab(value)}
          aria-label="Customer tabs"
        >
          <Tab data-testid={testIds.viewCustomerDetails} label={t("details")} value="DETAILS" />
          <Tab data-testid={testIds.viewCustomerBilling} label={t("billing")} value="BILLING" />
          <Tab data-testid={testIds.viewCustomerRating} label={t("rating", "Rating")} value="RATING" />
        </TabList>
      </Box>
      <TabPanel value="DETAILS">
        <BusinessEntityDetailsContainer
          businessEntityId={id}
          onLoad={onLoad}
          urlPrefix="/customers"
        />
      </TabPanel>
      <TabPanel value="BILLING">
        <Button data-testid={testIds.viewCustomerOpenNationalFuelRateTable}
          color="accent"
          variant="contained"
          onClick={() => {
            setIsRateTableOpen(true);
          }}
          sx={{
            my: 1,
          }}
        >
          {t(
            "billingRules:viewNationalFuelRateTable",
            "View national fuel rate table"
          )}
        </Button>
        <BillingRulesEditor
          customerId={id}
          customerType={BusinessEntityType.Customer}
        />
        <NationalFuelRateTableDialog
          isOpen={isRateTableOpen}
          onClose={() => setIsRateTableOpen(false)}
        />
      </TabPanel>
      <TabPanel value="RATING">
        <RatingTableEditorContainer
          entityType={RateTableEntityType.Customer}
          entityId={id}
        />
      </TabPanel>
    </TabContext>
  );
}

export default ViewCustomer;
